




































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ColItemData, getUnitAnalyze } from '@/api/common/analyze'
import { DDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import { copyArray, toDefaultInt, tryToInt } from '@/configs/functions'
import PageList from '@/components/pageLayout/list.vue'

import myChart from '@/components/myChart/index.vue'
import {
  PagePermissionState, PermissionData, FailedPermission
} from '@/store/modules/pagePermission'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
const UserModule = namespace('user')
const DataSourceModule = namespace('dataSource')

@Component({
  components: {
    myChart, PageList
  }
})
export default class AnalyzeUnit extends Vue {
  @UserModule.Getter('userInfo')
  public curUser!: UserData

  public get cityId(): number {
    if (this.curUser) {
      /* 
    1.省文物局 2.省财政局 3.市文物局 4.市财政局 5.区县 
    6.评估机构 7.评估专家 8.文保单位 9.巡查人员
    */
      const u = this.curUser
      const userType = u.UserType
      if (userType == 3 || userType == 4) {
        return u.CityId
      }
    }
    return 0
  }
  public area: any = null
  public level: any = null
  public classify: any = null
  public firstType: number = enFirstType.All
  public cityList: DDLItem[] = []
  public classifyList: DDLItem[] = []
  public levelList: DDLItem[] = []
  public listLoading: boolean = true
  public queryTerm = {
    CityId: this.cityId,
    LevelId: 0,
    ClassifyId: 0
  }
  public getQueryTerm() {
    const query = this.$route.query
    // 从页面Url中获取参数
    this.queryTerm = {
      CityId: toDefaultInt(query['CityId'], this.cityId),
      LevelId: tryToInt(query['LevelId']),
      ClassifyId: tryToInt(query['ClassifyId'])
    }
  }
  public created() {
    this.getQueryTerm()
    this.fetchSource()
  }
  public mounted() {
    this.doSearch()
  }
  // 点击查询按钮时，页码需要重置为1
  public doSearch() {
    this.fetchData()
  }
  @DataSourceModule.Getter('unitLevel')
  public unitLevel!: any
  @DataSourceModule.Getter('unitClassify')
  public unitClassify!: any
  @DataSourceModule.Getter('cityList')
  public cityCounty!: any
  // 数据项加载
  public fetchSource() {
    var unitLevel = copyArray(this.unitLevel)
    if (unitLevel) {
      this.levelList = unitLevel
    }
    var unitClassify = copyArray(this.unitClassify)
    if (unitClassify) {
      this.classifyList = unitClassify
    }
    var cityCounty = copyArray(this.cityCounty)
    if (cityCounty) {
      this.cityList = cityCounty
    }
  }
  public fetchData() {
    this.listLoading = true
    getUnitAnalyze(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.area = data.areaData
        this.level = data.levelData
        this.classify = data.classifyData
      }
      this.listLoading = false
    })
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.getQueryTerm()
    this.fetchData()
  }
}
